import { render } from "./ConfigVariableSelector.vue?vue&type=template&id=ec07ae38&ts=true"
import script from "./ConfigVariableSelector.vue?vue&type=script&lang=ts"
export * from "./ConfigVariableSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__